import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=356c746e&scoped=true"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"
import style0 from "./basic.vue?vue&type=style&index=0&id=356c746e&prod&lang=scss&scoped=true"
import style1 from "./basic.vue?vue&type=style&index=1&id=356c746e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356c746e",
  null
  
)

export default component.exports